export default __webpack_public_path__ + "static/programming4-ccf6b6321cb5ab065d13e7839676e7dd.png";